import { render, staticRenderFns } from "./editHelpdesk.vue?vue&type=template&id=254a86ad&scoped=true&"
import script from "./editHelpdesk.vue?vue&type=script&lang=js&"
export * from "./editHelpdesk.vue?vue&type=script&lang=js&"
import style0 from "./editHelpdesk.vue?vue&type=style&index=0&id=254a86ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254a86ad",
  null
  
)

export default component.exports